export const DAD_STAGE_OPTIONS = [
  { value: 'all', label: 'All Dads' },
  { value: 'prospect', label: 'Prospects' },
  { value: 'webinar_invited', label: 'Webinar Invited' },
  { value: 'webinar_registered', label: 'Webinar Registered' },
  { value: 'webinar_attended', label: 'Webinar Attended' },
  { value: 'dad_partners_founding_forty_considering', label: 'Dad Partners Founding Forty Considering' },
  { value: 'dad_partners_founding_forty_joined', label: 'Dad Partners Founding Forty Joined' },
  { value: 'member', label: 'Members' },
  { value: 'not_now', label: 'Not Now' },
];

export const DAD_STAGE_JOIN_PRIORITY = {
  all: 0,
  dad_partners_founding_forty_considering: 1,
  dad_partners_founding_forty_joined: 2,
  prospect: 3,
  webinar_attended: 4,
  webinar_registered: 5,
  webinar_invited: 6,
  member: 7,
  not_now: 8,
};

export const CAMPAIGN_OPTIONS = [
  { value: '', label: 'General' },
  { value: 'dad_partners_founding_forty', label: 'Dad Partners Founding Forty' },
];

export const WARMTH_OPTIONS = [
  { value: '', label: 'Not set' },
  { value: 'warm', label: 'Warm' },
  { value: 'cold', label: 'Cold' },
];

export const SOURCE_OPTIONS = [
  { value: '', label: 'Not set' },
  { value: 'warm_personal', label: 'Warm Personal' },
  { value: 'facebook_group', label: 'Facebook Group' },
  { value: 'facebook_post', label: 'Facebook Post' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'referral', label: 'Referral' },
  { value: 'luma_public', label: 'Luma Public' },
];

export const CHILDREN_AGE_OPTIONS = [
  { value: '', label: 'Not set' },
  { value: '0-5', label: '0-5' },
  { value: '6-12', label: '6-12' },
  { value: '13-18', label: '13-18' },
  { value: 'mixed_ages', label: 'Mixed Ages' },
  { value: 'not_currently_at_home', label: 'Not Currently at Home' },
];

export const PRESSURE_AREA_OPTIONS = [
  { value: '', label: 'Not set' },
  { value: 'parenting', label: 'Parenting' },
  { value: 'marriage', label: 'Marriage' },
  { value: 'career', label: 'Career' },
];

export const MEMBER_TIER_OPTIONS = [
  { value: 'admin', label: 'Admin' },
  { value: 'moderator', label: 'Moderator' },
  { value: 'prospect', label: 'Prospect' },
  { value: 'member', label: 'Member' },
  { value: 'guide_partner', label: 'Guide Partner' },
  { value: 'support_partner', label: 'Support Partner' },
  { value: 'advisory_partner', label: 'Advisory Partner' },
  { value: 'guest', label: 'Guest' },
  { value: 'beta_tester', label: 'Beta Tester' },
  { value: 'visitor', label: 'Visitor' },
];

export const ALL_MEMBER_TIERS = MEMBER_TIER_OPTIONS.map((option) => option.value);

export const getMemberTierLabel = (value) => (
  MEMBER_TIER_OPTIONS.find((option) => option.value === value)?.label || formatLabel(value)
);

export const MEMBER_TIER_COLORS = {
  admin: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/30',
  moderator: 'bg-purple-500/10 text-purple-500 border-purple-500/30',
  member: 'bg-aqua/10 text-aqua border-aqua/30',
  guide_partner: 'bg-cyan-500/10 text-cyan-400 border-cyan-500/30',
  support_partner: 'bg-rose-500/10 text-rose-400 border-rose-500/30',
  advisory_partner: 'bg-violet-500/10 text-violet-400 border-violet-500/30',
  super_fan: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/30',
  guest: 'bg-gray-500/10 text-gray-400 border-gray-500/30',
  beta_tester: 'bg-pink-500/10 text-pink-500 border-pink-500/30',
  visitor: 'bg-gray-500/10 text-gray-400 border-gray-500/30',
};

export const stageColors = {
  prospect: 'bg-aqua/10 text-aqua border-aqua/30',
  webinar_invited: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/30',
  webinar_registered: 'bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 border-indigo-500/30',
  webinar_attended: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/30',
  dad_partners_founding_forty_considering: 'bg-orange-500/10 text-orange-700 dark:text-orange-300 border-orange-500/30',
  dad_partners_founding_forty_joined: 'bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/30',
  member: 'bg-aqua/10 text-aqua border-aqua/30',
  not_now: 'bg-gray-500/10 text-gray-600 dark:text-gray-400 border-gray-500/30',
};

export const DEFAULT_WEBINAR_IMPORT_KEY = 'dad_partners_founding_forty_webinar_2026_03_29';

export const formatLabel = (value) => {
  if (!value) return '';
  return value
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export const getDadCampaignDisplayLabel = (campaign) => {
  if (campaign?.campaign_branch === 'attended') return 'Attended Follow-Up';
  if (campaign?.campaign_branch === 'missed') return 'Missed-It Follow-Up';
  if (campaign?.campaign_purpose === 'webinar_invite') return 'Webinar Invite';
  return formatLabel(campaign?.campaign_branch || campaign?.campaign_purpose || 'webinar_invite');
};

export const getDadStageDisplayLabel = (value) => {
  const match = DAD_STAGE_OPTIONS.find((option) => option.value === value);
  return match?.label || formatLabel(value || '');
};

export const getDadRelationshipStage = (member) => {
  const storedStage = (member.relationship_stage || '').trim();
  if (storedStage) return storedStage;
  if ((member.tier || '') === 'prospect') return 'prospect';
  if ((member.tier || '') === 'member' || (member.cohorts || []).includes('founding40')) return 'member';
  return '';
};
